import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { Header, Header2, Header3 } from '@app/components/general/header'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { GrStar } from 'react-icons/gr'
import Image from 'next/image'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/vercel-integration',
    }),
  }
}

function VercelIntegration() {
  const { t } = useTranslation('vercel-integration')

  return (
    <MarketingDrawer>
      <SectionContainer container block>
        <div className='space-y-4'>
          <div>
            <Header>{t('header')}</Header>
            <Paragraph className='text-xl'>{t('header-d')}</Paragraph>
          </div>
          <div className='sr-only'>
            <Header2>{t('subtitle')}</Header2>
            <Paragraph>{t('subtitle-d')}</Paragraph>
          </div>
          <div className='border-2 w-full relative rounded'>
            <a
              className='absolute top-0 left-0 right-0 bottom-0 w-full h-full hover:bg-[rgba(30,30,30,.1)]'
              href={'https://vercel.com/integrations/a11ywatch'}
              rel='noopener'
              target='_blank'
            >
              <span className='sr-only'>{t('header')}</span>
            </a>
            <div className='place-content-center place-items-center flex bg-gray-900 dark:bg-white rounded-t h-40'>
              <Image
                src={'/img/vercel_logo.webp'}
                height={70}
                width={80}
                alt={t('vercel-logo')}
                className='invert dark:invert-0'
              />
            </div>
            <div className='p-3'>
              <Header3>{t('a11y')}</Header3>
              <div className='flex gap-2 place-items-center pb-1 text-sm'>
                <GrStar />
                {t('featured')}
              </div>
              <Paragraph>{t('main')}</Paragraph>
            </div>
          </div>

          <div className='py-6'>
            <div className='py-6 px-5 rounded'>
              <Paragraph className='text-lg leading-7'>
                {t('vercel-about')}
              </Paragraph>
            </div>
          </div>
        </div>
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { VercelIntegration },
  {
    translation: 'vercel-integration',
  }
)
